<div class="tw-flex tw-flex-col tw-items-start tw-w-full tw-gap-y-2">
    <pickright-label [label]="label" [required]="required" *ngIf="showLabel"></pickright-label>
    <div
        class="wrap-control tw-bg-surface-10 tw-flex tw-flex-row tw-w-full tw-items-center tw-rounded-lg tw-border-b1 tw-border tw-py-2 tw-px-4 tw-gap-x-4" [class]="cssClass">
        <ng-content select="[prefixIcon]"></ng-content>
        <input id="inputFeild" class="tw-bg-transparent tw-flex-1 tw-text-p2 tw-font-semibold tw-text-color-1 tw-placeholder-gray-400 tw-w-[inherit]" [style.text-transform]="'inherit'" 
            type="{{password? 'password' : (number?'number':'text')}}" [placeholder]="placeholder" [(ngModel)]="value"
            [ngModelOptions]="{standalone: true}" (ngModelChange)="onValueChange()" (focus)="markAsTouched()" 
            [ngClass]="{ 'is-invalid': inValidState&&isTouched }" autocomplete="off"
            [disabled]="disabled" [readOnly]="readOnly" *ngIf="!textarea" />
        <textarea id="textArea"
            class="tw-bg-transparent tw-flex-1 tw-text-p2 tw-font-semibold tw-text-color-1 tw-placeholder-gray-400 tw-resize-none tw-w-[inherit]" [style.text-transform]="'inherit'" 
            [placeholder]="placeholder" [(ngModel)]="value" [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onValueChange()" (focus)="markAsTouched()"
            [ngClass]="{ 'is-invalid': inValidState&&isTouched }" rows="{{rows}}" autocomplete="off"
            [disabled]="disabled" [readOnly]="readOnly" *ngIf="textarea"></textarea>
        <ng-content select="[postfixIcon]"></ng-content>
    </div>
    <ng-content select="[hint]"></ng-content>
    <pickright-error *ngIf="inValidState&&isTouched">
        <span>{{error|controlError:label}}</span>
    </pickright-error>
</div>